import { Collection, WhereField } from '../../shared/constants';
import { addDoc, deleteDoc, getAllDocsByClientId, getDocByQueries } from './collectionBaseWorker';
import { where } from "firebase/firestore"

export const getAllAccreditedTypes = async ({ clienteId }) => {
    const items = await getAllDocsByClientId({ collection: Collection.ACCREDITEDS_TYPES, clienteId: clienteId })
    return items.sort((a, b) => a.name.localeCompare(b.name))
}

export const getAccreditedTypeByName = async ({ clienteId, name }) => {
    const result = await getDocByQueries({
        collection: Collection.ACCREDITEDS_TYPES,
        queries: [
            where(WhereField.CLIENTEID, "==", clienteId),
            where(WhereField.NAME, "==", name)
        ]
    })
    return result
}

export const removeAccreditedType = async ({ id }) => {
    await deleteDoc({ collection: Collection.ACCREDITEDS_TYPES, id: id })
}

export const saveAccreditedType = async ({ name }) => {
    const data = {
        name: name
    }
    await addDoc({ collection: Collection.ACCREDITEDS_TYPES, data: data })
}